import { render, staticRenderFns } from "./FieldButton.vue?vue&type=template&id=faca9bfc&scoped=true"
import script from "./FieldButton.vue?vue&type=script&lang=js"
export * from "./FieldButton.vue?vue&type=script&lang=js"
import style0 from "./FieldButton.vue?vue&type=style&index=0&id=faca9bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faca9bfc",
  null
  
)

export default component.exports